import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: string[] = [];

export const FilesDescriptionSlice = createSlice({
  name: 'filesDescription',
  initialState,
  reducers: {
    setFilesDescription: (_state, action: PayloadAction<string[]>) => {
      return [...action.payload];
    },
    removeFilesDescription: () => {
      return initialState;
    },
  },
});

export default FilesDescriptionSlice.reducer;

export const { setFilesDescription, removeFilesDescription } =
  FilesDescriptionSlice.actions;
